const PageContainer = ({ children }) => {
  return (
    <main className="fixed top-16 left-0 right-0 bottom-0 lg:left-64 flex flex-col overflow-y-auto overflow-x-hidden bg-white [&::-webkit-scrollbar]:hidden" style={{ scrollbarWidth: 'none' }}>
      <div className="flex-1 p-0 md:p-0 lg:p-0">
        {children}
      </div>
    </main>
  );
};

export default PageContainer;
